import Tab from './Tab';
import type { TabProps } from './Tab';

export type { TabProps };
export default Tab;
